module.exports = __webpack_public_path__ + "static/media/TronLinkLogo.d3a8f115.png";